'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var nanoid = require('nanoid');
var classNames = require('classnames/bind');
var formik = require('formik');
var Switch_module = require('./Switch.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Switch_module["default"]);
var Switch = function (_a) {
    var ariaDescribedBy = _a.ariaDescribedBy, disabled = _a.disabled, helpText = _a.helpText, inline = _a.inline, label = _a.label, ariaLabel = _a.ariaLabel, required = _a.required, name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, onChangeCallback = _a.onChange, props = _tslib.__rest(_a, ["ariaDescribedBy", "disabled", "helpText", "inline", "label", "ariaLabel", "required", "name", "className", "onChange"]);
    var id = React.useMemo(function () { return "custom-switch-".concat(nanoid.nanoid()); }, []);
    var _c = formik.useField({ name: name }), _d = _c[0], value = _c[1].value, setValue = _c[2].setValue, field = _tslib.__rest(_d, []);
    var switchContainerClassnames = cx({
        switchContainer: true,
        className: className,
        inline: inline,
    });
    var handleChange = function (evt) {
        if (disabled)
            return;
        setValue(!value, false);
        if (onChangeCallback) {
            onChangeCallback(evt);
        }
    };
    return (jsxRuntime.jsxs("div", _tslib.__assign({ className: switchContainerClassnames }, { children: [jsxRuntime.jsx("button", _tslib.__assign({}, field, props, { id: id, type: "button", role: "switch", className: Switch_module["default"].slider, "aria-describedby": ariaDescribedBy, "aria-disabled": disabled, "aria-checked": value, "aria-label": label || ariaLabel, onClick: handleChange, name: name })), required ? (jsxRuntime.jsx("span", _tslib.__assign({ className: Switch_module["default"].required }, { children: "Required" }))) : (jsxRuntime.jsx("span", _tslib.__assign({ className: Switch_module["default"].label }, { children: label }))), helpText && (jsxRuntime.jsx("p", _tslib.__assign({ id: ariaDescribedBy, className: Switch_module["default"].checkboxHelpText }, { children: helpText })))] })));
};

exports["default"] = Switch;
//# sourceMappingURL=Switch.js.map
